import { Seo } from "@/components/Seo";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { CONTACT } from "@/data/content";

export const LegalPage = ({ overline, title, lede, sections, testId, seoDescription, updated }) => (
  <div data-testid={testId}>
    <Seo title={title} description={seoDescription || lede} />
    <PageHeader overline={overline} title={title} lede={lede} />
    <section className="mx-auto max-w-4xl px-4 py-16 sm:px-6">
      {updated && (
        <p data-testid={`${testId}-updated`} className="mb-10 inline-flex rounded-full bg-cream px-3 py-1.5 text-xs font-medium text-slate-600">
          Last updated: {updated}
        </p>
      )}
      <div className="card divide-y divide-slate-200">
        {sections.map((s, i) => (
          <Reveal key={s.heading} delay={Math.min(i * 0.03, 0.2)} y={12}>
            <article data-testid={`${testId}-section-${i + 1}`} className="p-6 md:p-8">
              <h2 className="flex items-baseline gap-3 font-display text-lg font-bold tracking-tight md:text-xl">
                <span className="text-sm font-semibold text-brand">{String(i + 1).padStart(2, "0")}</span>
                {s.heading}
              </h2>
              <div className="mt-3 text-sm leading-relaxed text-slate-600 md:text-base">{s.body}</div>
            </article>
          </Reveal>
        ))}
      </div>
      <p className="mt-8 text-xs text-slate-500">
        {CONTACT.name} · {CONTACT.email} · {CONTACT.phone} · {CONTACT.address}
      </p>
    </section>
  </div>
);
